import { render, staticRenderFns } from "./TakeOverAllEntries.vue?vue&type=template&id=20036851&scoped=true"
import script from "./TakeOverAllEntries.vue?vue&type=script&lang=js"
export * from "./TakeOverAllEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20036851",
  null
  
)

export default component.exports